import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { pad, useCountdown } from '../hooks/useCountdown';
export function UrgencyBanner() {
  const {
    h,
    m,
    s
  } = useCountdown();
  const reduceMotion = useReducedMotion();
  const time = `${pad(h)}:${pad(m)}:${pad(s)}`;
  const Group = ({
    hidden
  }: {
    hidden?: boolean;
  }) => <div aria-hidden={hidden} className="flex shrink-0 items-center gap-6 pr-6 md:gap-10 md:pr-10" data-id="element-313" data-mp="2wb8kr8b5x8gb">
      {[0, 1, 2].map(item => <React.Fragment key={item} data-id="element-314" data-mp="3191rc2gdo4h4">
          <span className="flex items-center gap-1.5 whitespace-nowrap text-amber-200" data-id="element-315" data-mp="3188kl1hf5eyz">
            <FlameIcon className="h-4 w-4" data-id="element-316" data-mp="369pkato62vdz" />
            LAUNCH PRICE ENDS IN: <span className="font-mono tabular-nums" data-id="element-317" data-mp="3b8ix0jvmqid3">{time}</span>
          </span>
          <span className="text-white/40" data-id="element-318" data-mp="1bvoj42559waq">•</span>
          <span className="whitespace-nowrap" data-id="element-319" data-mp="1bwzm3zqrn00s">75% OF SPOTS CLAIMED</span>
          <a href="#comprar" tabIndex={hidden || item > 0 ? -1 : undefined} className="whitespace-nowrap rounded-full bg-amber-400 px-2.5 py-1 text-[11px] font-bold text-blue-950 transition-colors duration-150 ease-out hover:bg-amber-200 md:px-3 md:text-xs" data-id="element-320" data-mp="1gv9gi84o1wlc">
            VIEW THE KIT →
          </a>
          <span className="text-white/40" data-id="element-321" data-mp="1xpycpvuvtgip">•</span>
        </React.Fragment>)}
    </div>;
  return <div className="sticky top-0 z-50 w-full overflow-hidden border-b border-amber-500/40 bg-blue-950 text-stone-50 shadow-md" data-id="element-322" data-mp="1sqlhontux351">
      <div className="py-2.5 text-[11px] font-semibold md:text-sm" data-id="element-323" data-mp="2qd2d1nj156o5">
        <motion.div className="flex w-max" animate={reduceMotion ? undefined : {
        x: ['0%', '-50%']
      }} transition={{
        duration: 30,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-324" data-mp="2le7v0nsvzm53">
          <Group data-id="element-325" data-mp="2ccrm6khpzs2z" />
          <Group hidden data-id="element-326" data-mp="2cd9re6md1gn1" />
        </motion.div>
      </div>
    </div>;
}